import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const IdentityIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 23.5 27"
    >
      <g transform="translate(-1460.218 -592)">
        <g transform="translate(1461.218 593)">
          <line
            x1="12.658"
            transform="translate(4.718 15.364)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <line
            x1="12.658"
            transform="translate(4.718 20.208)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <path
            d="M1.043,0H20.456A1.044,1.044,0,0,1,21.5,1.044V23.957A1.043,1.043,0,0,1,20.457,25H1.043A1.043,1.043,0,0,1,0,23.957V1.043A1.043,1.043,0,0,1,1.043,0Z"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
          <rect
            width="6.032"
            height="6.037"
            transform="translate(4.718 4.175)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
          />
        </g>
      </g>
    </svg>
  </CircledIcon>
);
